module.exports = __webpack_public_path__ + "static/media/zen-planner-logo.e61e31d1.png";